import { render, staticRenderFns } from "./new_fiat.vue?vue&type=template&id=1fa8be2c&scoped=true"
import script from "./new_fiat.vue?vue&type=script&lang=js"
export * from "./new_fiat.vue?vue&type=script&lang=js"
import style0 from "./new_fiat.vue?vue&type=style&index=0&id=1fa8be2c&prod&scoped=true&lang=css"
import style1 from "./new_fiat.vue?vue&type=style&index=1&id=1fa8be2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa8be2c",
  null
  
)

export default component.exports